import React, { PureComponent } from 'react'
import { Button, Spinner } from 'react-bootstrap';
import { styleRules, __pick } from './utils';
import PropTypes from 'prop-types';
const btnProps = [
    // HTML attributes
    "title",
    "style",
    "className",
    "disabled",
    "type",
    "id",
    // Event listeners
    "onFocus",
    "onBlur",
    "onClick",
    "onKeyDown",

];
const colors = {
    red: "#cc0000",
    green: "#198c19",
}
class ButtonLoadingOld extends PureComponent {
    _isMounted = false;

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            show: "",
            msg: "",
            isSuccessMsg: false,
        }
    }
    componentDidMount() {
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    showMsg(msg = "", isSuccessMsg = false) {
        this.setState({ show: true, msg: msg, isSuccessMsg: isSuccessMsg })
        setTimeout(() => {
            this._clearResult()
        }, 2000);
    }
    hiddenMsg() {
        this.setState({ show: false, msg: "" })
    }
    startFetching() {
        this.setState({ loading: true })
    }
    stopFetching() {
        this.setState({ loading: false })
    }
    startLoading() {
        this.setState({ loading: true })
    }
    stopLoading() {
        this.setState({ loading: false })
    }
    _clearResult = () => {
        if (this._isMounted) {
            this.setState({
                loading: false,
                msg: "",
                show: false,
                isSuccessMsg: false
            }, () => { this.forceUpdate() })
        }

    }
    onClick = (e) => {
        if (this.props.onClick) {
            return this.props.onClick(e)
        }
        if (this.props.onPress) {
            return this.props.onPress()
        }
    }
    render() {
        let styleBtn = this.props.style && styles.button
        const { loading, show } = this.state
        const { block } = this.props
        let classBtn = this.props.useClassBtn ? "btn" : ""
        let className = `${classBtn} ${this.props.className} ${block ? "btn-block" : ""}`
        let CustomButton = this.props.customButton;

        if (this.state.show) {
            return (
                <span className="text-center" style={{ flex: 1, padding: 5, alignContent: 'center', justifyContent: 'center', alignItems: 'center' }}>
                    <span style={{ color: this.state.isSuccessMsg ? colors.green : colors.red }} >{this.state.msg}</span>
                </span>
            )
        }
        // if (this.state.loading) {
        //     return (
        //         <div className="text-center">
        //             <Spinner animation="border" variant="success" />
        //         </div>)
        // }
        if (CustomButton && CustomButton != null) {
            return (
                <CustomButton
                    {...__pick(this.props, btnProps)}
                    disabled={loading ? true : this.props.disabled}
                    className={className}
                    onClick={(e) => this.onClick(e)}  >
                    {loading ? <>   <Spinner animation="border" {...this.props.propsSpinner} /> Loading... </>
                        : this.props.children}
                </CustomButton>
            )
        }
        return (
            <button
                {...__pick(this.props, btnProps)}
                disabled={loading ? true : this.props.disabled}
                className={className}
                onClick={(e) => this.onClick(e)}  >
                {loading ? <>   <Spinner animation="border" {...this.props.propsSpinner} /> Loading... </>
                    : this.props.children}
            </button>
        )
    }
}
ButtonLoadingOld.propTypes = {
    block: PropTypes.bool,
}
ButtonLoadingOld.defaultProps = {
    disabled: false,
    useClassBtn: true,
    customButton: null,
    propsSpinner: {},
    type: "button",
    default: true,
    block: false,
    className: "",
    style: {
        backgroundColor: ''
    }
}
export default ButtonLoadingOld;
export { ButtonLoadingOld };
const styles = {
    button: {
        textAlign: "center",
        backgroundColor: 'transparent',
        paddiBottom: 6,
        paddingTop: 6,
        paddingLeft: 12,
        paddingRight: 12,
        borderWidth: 0,
        borderColor: "#fff",
        cursor: "pointer",
        fontSize: 15,
        color: "#000",
        outline: "0",
        margin: 5,
    }
}